const STRIPE_PUBLISHABLE = process.env.REACT_APP_STAGE === 'production'
  ? 'pk_live_pm1Cwv134bfnK41GjqKCD78h'
  : 'pk_test_zUQdZfb8NC1P6FgKnWP4Q5N3';

export default STRIPE_PUBLISHABLE;



// WEBPACK FOOTER //
// ./src/constants/stripe.js